import Masonry from 'masonry-layout'
import jQueryBridget from 'jquery-bridget'
import imagesLoaded from 'imagesloaded'
import infinitescroll from 'infinite-scroll'
import 'slick-carousel'
const w = window,
      d = document

export default () => {

  jQueryBridget( 'masonry', Masonry, $ )
  jQueryBridget( 'infiniteScroll', infinitescroll, $ )
  jQueryBridget( 'imagesLoaded', imagesLoaded, $ )

  $(() => {

    infinitescroll.imagesLoaded = imagesLoaded;
    const $grid = $('[data-plugin="masonry"]'),
          msnry = $grid.data('masonry')

    $grid.imagesLoaded(function() {
      $grid.masonry( 'option', { itemSelector: '.grid-item' });
      var $items = $grid.find('.grid-item');
      $grid.masonry( 'appended', $items );
    })

    $grid.infiniteScroll({
      path: '#more a',
      append: '.grid-item',
      outlayer: msnry,
      status: '.page-load-status',
    })
    
    $("#more a").click(function(){
      $grid.infiniteScroll('loadNextPage')
      return false
    });

  })

  $(function(){

    // アイテムクリックで擬似詳細ページ表示
    (function(item,pushState){
      if(!pushState) return false;
      if($(item).length > 0){
        var $detail_stage = $('<div>',{class:'books__stage'});
        $('body').append($detail_stage);
      }
      $(d).on('click',item,function(){
        var $this = $(this),
            href = $this.attr('href');
        insertDetail(href);
        w.history.pushState({books_stage:true},null,href);
        return false;
      });

      // 戻る・進む動作
      $(w).on('popstate',function(e){
        e.preventDefault();
        var currentUrl = getCurrentPage(),
            listcond = [/\/works\/$/,/\/works-category\/[^/]+\//];
        if(listcond[0].test(currentUrl) || listcond[1].test(currentUrl) ){ // 一覧ページURLだったら
          if($('body').hasClass('single'))
            location.reload();
          else
            $detail_stage.removeClass('active');
            $('body').removeClass('detail_active');
        }else{
          insertDetail(currentUrl);
        }

      });

      //現在のページ名を取得する
      function getCurrentPage(){
        return location.pathname;
      }
      function insertDetail(href){
        var $fr = $('<iframe>',{
              class:'books__stage__iframe',
              src:href
            });
        $detail_stage.empty().append($fr).addClass('active');
        $('body').addClass('detail_active');
      }
    }( // param
      '.books__list .books__item__link',
      (typeof w.history.pushState == 'function')
    ));

    // フレーム内でリンクをクリックした場合はターゲットを親ウインドウにする
    (function(link,is_child,p){
      if(!is_child) return false;
      $(link).on('click',function(){
        $(this).attr(p[0],p[1]);
      });
    }( 'a:not([target])', w!=w.parent, ['target','_parent'] ));

  });

  $(w).on('load',function(){


    // FI/FO
    $('[class*="sliderControl__arrows"]').on('click',function(){
      return false;
    });
    var book = $('[data-plugin="slick"]').slick({
      dots: false,
      fade: true,
      cssEase: 'linear',
      arrows: true,
      useTransform: true,
      speed: 600,
      adaptiveHeight: true,
      prevArrow: $('.sliderControl__arrows-left'),
      nextArrow: $('.sliderControl__arrows-right')
    });
    // スライド数表示
    (function(_){
      var slides = _.s.slick('getSlick');
      var mq = window.matchMedia('(max-width: 767px)');
      if(slides.slideCount > 0){
        _.setAmount( (slides.currentSlide+1), slides.slideCount );
        _.s.on('beforeChange',function(e,slides,currentSlide,nextSlide){
          _.setAmount( (nextSlide+1), slides.slideCount );
        });
        $(window).on('resize', function(){
          if( !mq.matches ){
            _.s[0].slick.refresh();
          }
        });
      }else{
        _.$target.hide();
        _.$controls.hide();
      }
    }({
      s: book,
      $target: $('.sliderControl__amount'),
      $controls: $('[class*=sliderControl__arrows-]'),
      setAmount: function(current,slides){
        this.$target.text(current+'|'+slides);
      }
    }));

    // ページトップリンクをスクロール量で表示する
    $.scrollspy({
      trigger:200,
      onBefore: function(){
        $('.bookNav-footer').addClass('hidden');
      },
      onAfter: function(){
        $('.bookNav-footer').removeClass('hidden');
      }
    });

  });
}